import { Trans } from "@lingui/react/macro";
import React from "react";
import { useLocation } from "react-router-dom";

import { Info, Pending } from "@/common/components/info/info";
import { useCompany } from "@/common/providers/company-provider";

const SwitchCompany = () => {
  const { state } = useLocation();
  const { setActiveCompany } = useCompany();
  const companyName = state.company.name;

  React.useEffect(() => {
    setActiveCompany(state.company);
    setTimeout(() => {
      window.location.assign("/");
    }, 250);
  }, [setActiveCompany, state.company]);

  return (
    <div className="h-full flex">
      <Info>
        <p className="mb-2">
          <Trans>Přepínáme vás do společnosti {companyName}</Trans>
        </p>
        <Pending />
      </Info>
    </div>
  );
};

export { SwitchCompany };
